document.addEventListener("DOMContentLoaded", () => {
    let ignoreNextScroll = false;
    let lastScrollY = window.scrollY;
    let popupOpened = false;
    let scrollPosition = 0;

    window.addEventListener("scroll", () => {
        const delta = Math.abs(window.scrollY - lastScrollY);
        lastScrollY = window.scrollY;

        if (ignoreNextScroll || delta < 10 || popupOpened) return;

        document.querySelector('#input-search')?.classList.add('d-none');

        const goToTopButton = document.querySelector('.js-gototop');
        if (goToTopButton) {
            if (window.scrollY > 150) {
                goToTopButton.classList.remove('d-none');
            } else {
                goToTopButton.classList.add('d-none');
            }
        }
    });

    if (document.querySelectorAll('.js-open-search').length > 0) {
        let searchLinks = document.querySelectorAll('.js-open-search');

        for (const searchLink of searchLinks) {
            if (!searchLink.dataset.input) {
                console.error("data-input attribute is missing on: ", searchLink);
                continue;
            }

            searchLink.addEventListener('click', function (e) {
                const isInsideForm = e.target.closest('#input-search');
                if (isInsideForm && !e.currentTarget.contains(e.target.closest('.js-open-search'))) {
                    return;
                }

                e.preventDefault();
                const inputSelector = searchLink.dataset.input;
                const inputElement = document.querySelector(inputSelector);

                if (!inputElement) {
                    console.error("Element not found for selector: ", inputSelector);
                    return;
                }

                const inputSearchId = window.innerWidth < 992 ? '#inputSearchSm' : '#inputSearchLg';
                const focusElement = document.querySelector(inputSearchId);

                const openPopup = () => {
                    inputElement.classList.remove('d-none');
                    popupOpened = true;
                    document.querySelector('header').classList.add('menu-open');

                    // Empêche scroll
                    scrollPosition = window.scrollY;
                    document.body.style.position = 'fixed';
                    document.body.style.top = `-${scrollPosition}px`;
                    document.body.style.width = '100%';

                    if (typeof drawer !== 'undefined' && typeof navButton !== 'undefined') {
                        drawer.close();
                        navButton.classList.remove('js-is-active');
                    }

                    for (const s of searchLinks) {
                        s.classList.add('js-is-active');
                    }

                    if (focusElement) {
                        ignoreNextScroll = true;
                        setTimeout(() => {
                            ignoreNextScroll = false;
                            focusElement.focus(); // focus différé pour iOS
                        }, 300);
                    }
                };

                const closePopup = () => {
                    inputElement.classList.add('d-none');
                    popupOpened = false;
                    document.querySelector('header').classList.remove('menu-open');

                    // Restaure scroll
                    document.body.style.position = '';
                    document.body.style.top = '';
                    document.body.style.width = '';
                    window.scrollTo(0, scrollPosition);

                    for (const s of searchLinks) {
                        s.classList.remove('js-is-active');
                    }
                };

                if ((window.innerWidth + 15) < 1400) {
                    if (searchLink.classList.contains("js-is-active")) {
                        closePopup();
                    } else {
                        openPopup();
                    }
                } else {
                    if (searchLink.classList.contains("js-is-active")) {
                        closePopup();
                    } else {
                        openPopup();
                    }
                }
            });
        }
    }

    // Supprimer propagation inutile sur input (touchstart/end souvent problématiques)
    const inputSearch = document.querySelector('#inputSearch');
    if (inputSearch) {
        inputSearch.addEventListener('click', e => e.stopPropagation());
    }
});